module.exports = __webpack_public_path__ + "media/images/icons/ic-like-56e96779790a5f555731c2c9fe51f198.svg";